export const nextPageIsAvailable = (
	{ state, getters, commit }: any,
	loadingKey: any,
): boolean => !state.isEndPage && !getters[loadingKey];